import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 
              className="text-2xl font-bold text-teal-400 mb-4"
              style={{ fontFamily: '"Pacifico", serif' }}
            >
              Roba Temizlik
            </h3>
            <p className="text-gray-400 mb-4">
              {t('footer.description')}
            </p>
            <div className="flex space-x-4">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
              <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-2xl"></i>
              </a>
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-instagram-fill text-2xl"></i>
              </a>
              <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
              <a href="https://wa.me/905346818688" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                <i className="ri-whatsapp-fill text-2xl"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li>
                <button onClick={() => scrollToSection('services')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.services')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('why-us')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.whyUs')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('process')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.process')}
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('portfolio')} className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  {t('nav.portfolio')}
                </button>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.services')}</h4>
            <ul className="space-y-2">
              <li className="text-gray-400">Hastane Temizliği</li>
              <li className="text-gray-400">AVM Temizliği</li>
              <li className="text-gray-400">İnşaat Sonrası Temizlik</li>
              <li className="text-gray-400">Okul Temizliği</li>
              <li className="text-gray-400">Banka Temizliği</li>
              <li className="text-gray-400">Spor Salonu Temizliği</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer.contact')}</h4>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-map-pin-line text-teal-400 mt-1 mr-2"></i>
                <span className="text-gray-400">Çobançeşme, Sanayi Cd. No: 44, PK:34196<br />Bahçelievler/İstanbul</span>
              </li>
              <li className="flex items-center">
                <i className="ri-phone-line text-teal-400 mr-2"></i>
                <a href="tel:+905346818688" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  0534 681 8688
                </a>
              </li>
              <li className="flex items-center">
                <i className="ri-mail-line text-teal-400 mr-2"></i>
                <a href="mailto:robatemizlik@gmail.com" className="text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                  robatemizlik@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm mb-4 md:mb-0">
            © 2024 Roba Temizlik. {t('footer.rights')}
          </p>
          <div className="flex space-x-6">
            <a href="#" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
              {t('footer.terms')}
            </a>
            <a href="https://readdy.ai/?origin=logo" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-teal-400 text-sm transition-colors cursor-pointer">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
